/* Vipps checkout button handler */
(function () {
  'use strict';

  function initVippsButtons() {
    document.querySelectorAll('[data-vipps-checkout]').forEach(function (btn) {
      if (btn._vippsInit) return;
      btn._vippsInit = true;

      btn.addEventListener('click', function (e) {
        e.preventDefault();

        var formId = btn.getAttribute('data-form-id');
        var form = document.getElementById(formId);
        if (!form) return;

        var variantInput = form.querySelector('[name="id"]');
        var qtyInput = form.querySelector('[name="quantity"]');
        if (!variantInput) return;

        var variantId = parseInt(variantInput.value, 10);
        var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;

        btn.disabled = true;
        btn.style.opacity = '0.7';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Cart error');
            window.location.href = '/checkout';
          })
          .catch(function (err) {
            console.error('Vipps checkout error:', err);
            btn.disabled = false;
            btn.style.opacity = '';
          });
      });
    });
  }

  // Init on load and re-init after Shopify section re-renders
  document.addEventListener('DOMContentLoaded', initVippsButtons);
  document.addEventListener('shopify:section:load', initVippsButtons);

  // ── Hide kit-pattern products from collection pages ──
  function hideKitPatternProducts() {
    document.querySelectorAll('[data-product-options]').forEach(function(el) {
      try {
        var opts = JSON.parse(el.getAttribute('data-product-options'));
        if (opts.handle && opts.handle.indexOf('-kit-pattern') !== -1) {
          var card = el.closest('.t4s-col-item') || el.parentElement;
          if (card) card.style.display = 'none';
        }
      } catch(e) {}
    });
  }
  document.addEventListener('DOMContentLoaded', hideKitPatternProducts);
  setTimeout(hideKitPatternProducts, 1000);

  // ── Remove pre-order from kit product ──
  function removeKitPreOrder() {
    document.querySelectorAll('a[href*="agnes-camisole-yarn-kit"]').forEach(function(link) {
      var card = link.closest('li, .t4s-col-item, [class*="product"]') || link.parentElement;
      card.querySelectorAll('[class*="pre"], [class*="preOrder"], [class*="pre-order"]').forEach(function(el) {
        el.style.display = 'none';
      });
      // Fix button text if it says Pre order
      card.querySelectorAll('button, .t4s-btn-atc').forEach(function(btn) {
        if (btn.textContent.toLowerCase().includes('pre order') || btn.textContent.toLowerCase().includes('pre-order')) {
          btn.textContent = 'Add to Cart';
        }
      });
    });
  }
  document.addEventListener('DOMContentLoaded', removeKitPreOrder);
  setTimeout(removeKitPreOrder, 1500);

  // ── Add "Fra" prefix to kit product price ──
  function addFraPrefix() {
    document.querySelectorAll('a[href*="agnes-camisole-yarn-kit"]').forEach(function(link) {
      var card = link.closest('li, .t4s-col-item, .t4s-product-item, [class*="product"]') || link.parentElement;
      var priceEl = card.querySelector('[data-product-price], [data-pr-price], .t4s-product-price, .money');
      if (priceEl && !priceEl.textContent.includes('Fra')) {
        priceEl.innerHTML = 'Fra ' + priceEl.innerHTML;
      }
    });
  }
  document.addEventListener('DOMContentLoaded', addFraPrefix);
  // Also run after lazy loads
  setTimeout(addFraPrefix, 1500);

  // ── Default sort logic ──
  document.addEventListener('DOMContentLoaded', function() {
    var path = window.location.pathname;
    var search = window.location.search;

    // Best sellers default on /collections/best-sellers and /collections/shop
    if ((path === '/collections/best-sellers' || path === '/collections/shop') &&
        !search.includes('sort_by')) {
      var sep = search ? '&' : '?';
      window.location.replace(path + search + sep + 'sort_by=best-selling');
      return;
    }
  });

  // ── Move "English & Norwegian" to second line of product title ──
  function splitTitleLang() {
    document.querySelectorAll('.t4s-product__title').forEach(function(el) {
      if (el._langSplit) return;
      el._langSplit = true;
      el.innerHTML = el.innerHTML.replace(
        /\s*\(?(English\s*(?:&amp;|&)\s*Norwegian)\)?/gi,
        '<br><span class="t4s-title-lang">$1</span>'
      );
    });
  }

  document.addEventListener('DOMContentLoaded', splitTitleLang);
  document.addEventListener('shopify:section:load', splitTitleLang);
})();
